import { getClientCustomerIo } from '@brands/services/identity/getClientCustomerIo';
import { getCurrentProfile } from '@brands/services/identity/getCurrentProfile';
import { UserProfile } from '@brands/services/identity/types/UserProfile';
import { createCustomerIoTracker, customerIoAnalytics } from '@brands/Utils/customerIo';
import { jwtToken } from '@brands/Utils/getToken';
import { BrowserHistory } from 'history';
import { useEffect, useMemo } from 'react';

export function useCustomerIo(history: BrowserHistory, user: UserProfile | null): void {
  const tracker = useMemo(
    () =>
      createCustomerIoTracker({
        getToken: jwtToken,
        getProfile: getCurrentProfile,
        getClientRouting: getClientCustomerIo,
        getLocation: () => window.location,
        analytics: customerIoAnalytics,
        defaultKey: process.env.REACT_APP_CUSTOMER_IO_API_KEY,
      }),
    [],
  );
  const token = jwtToken();
  const clientPolicy = JSON.stringify(user?.clients);

  useEffect(() => {
    tracker.invalidateProfile();
    void tracker.page();
    const unlisten = history.listen(() => void tracker.page());
    return () => {
      unlisten();
      tracker.stop();
    };
  }, [tracker, history, token, user?.id, user?.role?.name, user?.disable_customerio, clientPolicy]);
}
